import React, { Component } from "react"
import { connect } from 'react-redux'

import {
    notebookSection,
    incProtocolPage,
    decProtocolPage,
    goProtocolPage,
    setPageInstructions,
    toggleNotesView,
    setModal,
    showModal
} from '../../../actions'

import ProtocolTask from './protocolTask/ProtocolTask'
import NotesView from './NotesView'

// Styles
import colors from 'styles/_exports.module.scss';
import "./ProtocolView.scss"

//Icons
import IconNotebook from 'components/icons/notebook-solid';
import IconHexagon from 'components/icons/hexagon-solid';
import IconStart from 'components/icons/start-solid';

import { withTranslation } from 'react-i18next'
import {LogEvent} from '@learningblocks/shared-components/lib/EventLogger'; 

class ProtocolView extends Component {

    renderProgress = () => {
        return (
          <div>
            <div className="progress">
              {this.renderProgressBar()}
            </div>
            <span className="progress-step">{this.props.currentPage}/{this.props.totalPages}</span>
          </div>
        )
    }

    renderProgressBar = () => {
      //const currentPage = this.props.currentPage

      return (this.props.tasks.map((task, index)=>(
        <LogEvent
          logEventProps={{
            event_type: "sim_protocol_part viewed",
            event_schema: "protocolpart",
            part_number: index +1
          }}
          actionProps={{ onClick: { action: 'clicked' } }}
          elementType="button"
        >
          <div className={"progress-bar"+(this.props.currentPage >= (index + 1)? " active":"")}
            onClick={()=>{
              this.pageInstruction.focus()
              this.taskList.scrollTop = 0
              this.props.goProtocolPage(index + 1)
            }}
            key={index}
            role="progressbar"
            style={{width: (100 / this.props.totalPages)+"%"}}
            aria-valuenow="15"
            aria-valuemin="0"
            aria-valuemax="100">
          </div>
        </LogEvent>
      )))
    }

    renderPageInstructions = () => {
        if(this.props.tasks.length > 0){
            return (
                <p tabIndex="0" ref={(pageInstruction)=>{this.pageInstruction = pageInstruction}} className="section-instruction">
                  {this.props.currentPage +". "+ this.props.t(this.props.tasks[this.props.currentPage - 1].instruction)}
                </p>
            )
        } else {
            return (
                <p className="section-instruction">
                  {this.props.t("0. No tasks found")}
                </p>
            )
        }
    }

    renderTaskPage = () => {
        if(this.props.tasks.length > 0){
            const currentPage = this.props.currentPage
            //Return list of tasks for rendering

            return (this.props.tasks[currentPage-1].tasks.map((task, index)=>(
                <ProtocolTask
                    key={index}
                    pIndex={currentPage-1}
                    tIndex={task.index}
                    level={"l"+this.props.level}
                    page={currentPage}
                    />
            )))
        } else {
            return (
                <div>
                    {this.props.t("No tasks yet...")}
                </div>
            )
        }
    }

    prevBtnClass = () => {
        if(this.props.currentPage !== 1){
            return "protocol-btn"
        } else {
            return "protocol-btn hide"
        }
    }

    blockNextBtn = () => {
        const finalCriteria = true

        // this.props.blotSolutions.forEach(solution => {
        //   finalCriteria = solution.used && finalCriteria
        // });

        return ( this.props.currentPage === this.props.totalPages && !finalCriteria )
    }

    backToNotebook = () => {
        this.props.notebookSection({section: null})
    }

    nextClicked = () => {
        this.props.incProtocolPage()
        this.pageInstruction.focus()
        this.taskList.scrollTop = 0
    }

    prevClicked = () => {
        this.props.decProtocolPage()
        this.pageInstruction.focus()
        this.taskList.scrollTop = 0
    }

    getCurrentTaskIndicator = () => {
      let page = 1;
      let task = 1;

      for (let i = 0; i < this.props.tasks.length; i++) {
        const taskPage = this.props.tasks[i]

        if( (this.props.focusedTask + 1) >= task && (this.props.focusedTask + 1) <= (task + taskPage.tasks.length)){
          return page+'.'+String.fromCharCode(97 + (this.props.focusedTask + 1) - task);      
        }
        page++;
        task += taskPage.tasks.length;
      }
    }

    getCurrentTaskPage = () => {
      let page = 1;
      const task = 1;

      for (let i = 0; i < this.props.tasks.length; i++) {
        const taskPage = this.props.tasks[i]

        if( (this.props.focusedTask + 1) >= task && (this.props.focusedTask + 1) <= (task + taskPage.tasks.length)){
          return page;
        }
        page++;
      }
    }

    showNotesView = () => {
      this.props.toggleNotesView(true);
    }

    componentDidMount() {

      this.props.setModal({
        display: false,
        type: "PROTOCOL_READ",
        size: 'md',
        connect: -1
      })
      this.props.showModal({display: true})
    }

    componentDidUpdate(prevProps){

      if(prevProps.modal.display === true && this.props.modal.display === undefined && this.props.modal.type === "PROTOCOL_READ"){
        this.pageInstruction.focus();
      }
    }

    render() {
        return (
          <div>
            <NotesView/>
            <div className="protocol-view" style={{display: (this.props.notesView)?"none": null}}>
                <div className="protocol-head">
                  <h4>
                    <div className="hexagon">
                      <IconHexagon
                        style={{ position: "absolute", top: "22px", left: "16px", color: 'white', height: '29px'}}
                      />
                    </div>
                    <span className="listIndex">{this.props.t(this.props.index + 1)}</span>
                    <button aria-label={this.props.t("Protocol menu button. Select to hide the Protocol instructions and simulation and display the menu.")}
                        className="protocol-title-btn"
                        onClick={this.backToNotebook}
                        style={{fontSize: '39px'}}>
                        {this.props.t("Protocol")}
                    </button>
                    <LogEvent
                      logEventProps={{
                        event_type: "sim_protocol_open_notes_btn clicked",
                        event_schema: "track"
                      }}
                      actionProps={{ onClick: { action: 'click' } }}
                      elementType="button"
                    >
                      <button onKeyDown={(e)=>{if(e.keyCode === 13 || e.keyCode === 32)this.showNotesView()}} onClick={this.showNotesView} aria-label={this.props.t("Notes button. Select to display any notes you’ve made throughout the simulation.")} className="protocol-notebook-btn">
                        <IconNotebook
                          style={{ color: "white", height: "16px", top: "2px"}}
                        /> {this.props.t("Notes")}
                      </button>
                    </LogEvent>
                  </h4>
                </div>
                <div className="protocol-progress-container">
                    {this.renderProgress()}
                    {this.renderPageInstructions()}
                </div>
                <div className="protocol-content" ref={(taskList) => { this.taskList = taskList; }}>
                  <div className="protocol-tasks-container">
                      {this.renderTaskPage()}
                  </div>
                  <div className="protocol-btns-container">
                      <LogEvent
                        logEventProps={{
                          event_type: "sim_protocol_previous_part_btn clicked",
                          event_schema: "protocolpart",
                          part_number: this.props.currentPage
                        }}
                        actionProps={{ onClick: { action: 'clicked' } }}
                        elementType="button"
                      >
                        <button aria-label={this.props.t("Previous button. Select to display the previous step in the protocol.")}
                            className={this.prevBtnClass()}
                            onClick={this.prevClicked}
                            style={{visibility: (this.props.currentPage===1)?"hidden":"visible"}}>
                            <IconStart
                              style={{ color: colors.navy1, height: "16px", top: "2px", transform: "rotate(180deg)"}}
                            /> {this.props.t("Previous")}
                        </button>
                      </LogEvent>
                      <LogEvent
                        logEventProps={{
                          event_type: "sim_protocol_part viewed",
                          event_schema: "protocolpart",
                          part_number: this.props.currentPage
                        }}
                        actionProps={{ onClick: { action: 'clicked' } }}
                        elementType="button"
                      >
                        <div className="indicator" onClick={()=>{this.props.goProtocolPage(this.props.focusedPage + 1)}}>
                          <span>{(this.props.focusedPage + 1)+'.'+this.props.t(String.fromCharCode(97 + (this.props.focusedTask)))}</span>
                          <IconHexagon
                            style={{ color: colors.navy1, height: '46px'}}
                          />
                        </div>
                      </LogEvent>
                      <LogEvent
                        logEventProps={{
                          event_type: "sim_protocol_next_part_btn clicked",
                          event_schema: "protocolpart",
                          part_number: this.props.currentPage
                        }}
                        actionProps={{ onClick: { action: 'clicked' } }}
                        elementType="button"
                      >
                        <button
                            aria-label={this.props.t("Next button. Select to display the next step in the protocol.")}
                            className={'protocol-btn' + (((this.props.focusedPage >= this.props.currentPage) || (this.props.currentPage === this.props.totalPages && this.props.taskPages[this.props.focusedPage].complete === true))?' active':'')}
                            onClick={this.nextClicked}
                            style={{visibility: (this.blockNextBtn() ? "hidden":"visible") }}>
                            <IconStart
                              style={{ color: colors.navy1, height: "16px", top: "2px"}}
                            /> {this.props.t("Next")}
                        </button>
                      </LogEvent>
                  </div>
                </div>
            </div>
          </div>
        );
    }
}


ProtocolView.defaultProps = {
    tasks: []
};

const mapStateToProps = (state, ownProps) => {
    return {
        sectionSelected: state.notebook.sectionSelected,
        currentPage: state.notebook.currentProtocolPage,
        totalPages: state.notebook.totalProtocolPages,
        pageInstructions: state.notebook.currentPageInstructions,
        focusedTask: state.notebook.focusedTask,
        focusedPage: state.notebook.focusedPage,
        taskPages: state.notebook.taskPages,
        tasks: ownProps.tasks,
        level: state.notebook.level,
        // blotSolutions: state.blotPaper.blotPapers[0].solutions,
        notesView: state.notebook.notesView,
        modal: state.modal
    }
}

export default connect(mapStateToProps, {
    notebookSection,
    incProtocolPage,
    decProtocolPage,
    goProtocolPage,
    setPageInstructions,
    toggleNotesView,
    setModal,
    showModal
})(withTranslation()(ProtocolView));
